export const MOCK_LIGHT_ID_PREFIX = 'mock-light-';

export const MOCK_LIGHT_GROUP_IDS = {
	rgbWw: -901,
	rgb: -902,
	cct: -903,
	dimmer: -904,
} as const;

export type MockLightCohort = keyof typeof MOCK_LIGHT_GROUP_IDS;

export const MOCK_LIGHT_GROUP_ID_LIST: number[] = Object.values(MOCK_LIGHT_GROUP_IDS);

export const mockLightId = (type: string, mode: string): string =>
	`${MOCK_LIGHT_ID_PREFIX}${type}-${mode}`;

export const isMockLightDeviceId = (id: string | number | null | undefined): boolean =>
	typeof id === 'string' && id.startsWith(MOCK_LIGHT_ID_PREFIX);

export const isMockLightGroupId = (id: string | number | null | undefined): boolean =>
	MOCK_LIGHT_GROUP_ID_LIST.includes(Number(id));

type MockLightLike = {
	id?: string;
	is_mock?: boolean;
};

export const isMockLightDevice = (deviceOrId: MockLightLike | string | null | undefined): boolean => {
	if (!deviceOrId) return false;
	if (typeof deviceOrId === 'string') return isMockLightDeviceId(deviceOrId);
	return deviceOrId.is_mock === true || isMockLightDeviceId(deviceOrId.id);
};

export const omitMockLightDevicesFromRecord = <T extends Record<string, unknown>>(
	record: T | null | undefined,
): T => {
	if (!record) return {} as T;
	const next = {} as T;
	for (const [id, value] of Object.entries(record)) {
		if (isMockLightDeviceId(id) || isMockLightDevice(value as MockLightLike)) continue;
		next[id as keyof T] = value as T[keyof T];
	}
	return next;
};

export const omitMockLightGroupsFromRecord = <T extends Record<string, unknown>>(
	record: T | null | undefined,
): T => {
	if (!record) return {} as T;
	const next = {} as T;
	for (const [id, value] of Object.entries(record)) {
		if (isMockLightGroupId(id) || isMockLightGroupId((value as { id?: number })?.id)) continue;
		next[id as keyof T] = value as T[keyof T];
	}
	return next;
};
